(function () {
  const videos = Array.from(document.querySelectorAll("[data-product-card-video]"));
  if (!videos.length) return;

  const pauseVideo = (video) => {
    video.pause();
  };

  const playVideo = (video) => {
    video.muted = true;
    video.playsInline = true;

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {
        pauseVideo(video);
      });
    }
  };

  if (!("IntersectionObserver" in window)) {
    videos.forEach(playVideo);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;

      if (entry.isIntersecting) {
        playVideo(video);
      } else {
        pauseVideo(video);
      }
    });
  }, {
    rootMargin: "120px 0px",
    threshold: 0.35
  });

  videos.forEach((video) => {
    pauseVideo(video);
    observer.observe(video);
  });
})();
